import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/message"
  }, React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.994747 11.851C1.03405 11.9225 1.05242 12.0036 1.04775 12.085C1.00254 12.4377 0.950765 12.7928 0.89949 13.1445C0.875903 13.3062 0.852423 13.4673 0.829737 13.627C0.780591 13.977 0.732522 14.3259 0.683594 14.6811C0.65088 14.9185 0.617782 15.1588 0.583721 15.404L0.743731 15.394C1.7888 15.248 2.82986 15.104 3.88393 14.964H3.93693C4.01955 14.9651 4.10074 14.9857 4.17395 15.024C5.34096 15.6583 6.64694 15.9936 7.97519 16C8.56886 15.9986 9.16065 15.9333 9.7403 15.805C11.6591 15.3769 13.3532 14.2574 14.4993 12.6602C15.6455 11.063 16.1636 9.09975 15.9547 7.145C15.7415 5.19016 14.817 3.38193 13.357 2.06445C11.8971 0.746973 10.0037 0.0122104 8.03719 0C6.48953 0.00185907 4.97537 0.450868 3.67692 1.293C1.48578 2.699 0.274702 4.752 0.0326863 7.341C-0.11158 8.90711 0.223957 10.4801 0.994747 11.851ZM6 8C6 8.55228 5.55228 9 5 9C4.44772 9 4 8.55228 4 8C4 7.44772 4.44772 7 5 7C5.55228 7 6 7.44772 6 8ZM8 9C8.55229 9 9 8.55228 9 8C9 7.44772 8.55229 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9ZM11 9C11.5523 9 12 8.55228 12 8C12 7.44772 11.5523 7 11 7C10.4477 7 10 7.44772 10 8C10 8.55228 10.4477 9 11 9Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Message16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Message16 = createIcon(IconComponent);